// extracted by mini-css-extract-plugin
export var productImage = "_o8-1";
export var viewLink = "_o8-2";
export var wishlistItem = "_o8-0";